const headUrl = "user/public";
const baseApi = {
    user: 'user/currentUser',
    parkDayFeeReport_home:"parkDayFeeReport/searchCashJudge",
    parkDayFeeReport:"parkDayFeeReport/searchCash",
    car_in_out_record:"online/park-lot-proxy?path=",
    except:"exceptionDoor/count",
    parkInfo:'park/findParkInfo',
    userSelectParkInfo:'park/userCurrentSelectParks',
    smsSend: headUrl+"/sendSmsCode",
    online_record:'order/search',
    save_park:'user/save'
};

export default baseApi;
